import genControlHeight from '../shared/genControlHeight';
import defaultAlgorithm from '../default';
import genCompactSizeMapToken from './genCompactSizeMapToken';
import getFontSizes from '../shared/genFontSizes';
const derivative = (token, mapToken) => {
    const mergedMapToken = mapToken !== null && mapToken !== void 0 ? mapToken : defaultAlgorithm(token);
    const fontSize = mergedMapToken.fontSizes[0]; // Smaller size font-size as base
    const fontSizes = getFontSizes(fontSize);
    const controlHeight = mergedMapToken.controlHeight - 4;
    return Object.assign(Object.assign(Object.assign(Object.assign({}, mergedMapToken), genCompactSizeMapToken(mapToken !== null && mapToken !== void 0 ? mapToken : token)), { 
        // font
        fontSizes: fontSizes.map((fs) => fs.size), lineHeights: fontSizes.map((fs) => fs.lineHeight), 
        // controlHeight
        controlHeight }), genControlHeight(Object.assign(Object.assign({}, mergedMapToken), { controlHeight })));
};
export default derivative;
